import React, { useEffect, useState } from 'react';
import { Button, Card, Title, Col as TremorCol } from '@tremor/react';
import { IonGrid, IonRow, IonCol, IonButton, IonIcon, IonText } from '@ionic/react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { OCCUPANT_TYPE, colorTheme } from '../../utils/constants';
import { chevronForward } from 'ionicons/icons';

ChartJS.register(ArcElement, Tooltip, Legend);

const OccupancyCard = ({ vacancies = 32, occupied = 100, percentageOccupied = 0, handleAddTenant, handleDeleteTenant, options, onClick, setUserViewPerms }) => {
    const [isDarkTheme, setIsDarkTheme] = useState(false);

    useEffect(() => {
        const checkTheme = () => {
            const darkThemeMq = window.matchMedia("(prefers-color-scheme: dark)");
            setIsDarkTheme(darkThemeMq.matches);
        };

        checkTheme();

        window.matchMedia("(prefers-color-scheme: dark)").addEventListener('change', (e) => {
            setIsDarkTheme(e.matches);
        });

        return () => {
            window.matchMedia("(prefers-color-scheme: dark)").removeEventListener('change', (e) => {
                setIsDarkTheme(e.matches);
            });
        };
    }, []);

    const doughnutData = {
        datasets: [
            {
                data: [percentageOccupied, 100 - percentageOccupied],
                backgroundColor: [
                    isDarkTheme ? colorTheme.primary["350"] : colorTheme.primary["700"],
                    colorTheme.primary["50"]
                ],
                hoverBackgroundColor: [
                    isDarkTheme ? colorTheme.primary["400"] : colorTheme.primary["800"],
                    colorTheme.primary["100"]
                ],
                borderWidth: 0
            }
        ]
    };

    const doughnutOptions = {
        cutout: '70%',
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            tooltip: {
                enabled: false
            },
            legend: {
                display: false
            },
        }
    };

    return (
        <TremorCol numColSpan={1} numColSpanLg={2}>
            <Card className="mb-3" style={{ height: "fit-content", borderRadius: "10px" }}>
                <Title className="mb-4 text-center">
                    Occupancy
                </Title>
                <IonGrid>
                    <IonRow className="d-flex align-items-center justify-content-center flex-column flex-md-row">
                        <IonCol size="12" sizeMd="3" className="text-center d-none d-md-block order-1 order-md-1 mb-2 mb-md-0">
                            <IonText color="primary" style={{ fontSize: '1.5em' }}>{vacancies}</IonText>
                            <h6>Vacant</h6>
                            <IonText color="primary" style={{ fontSize: '1.5em' }}>{occupied}</IonText>
                            <h6>Occupied</h6>
                        </IonCol>
                        <IonCol size="12" sizeMd="3" className="text-center d-md-none order-1 order-md-1 mb-2 mb-md-0">
                            <IonRow>
                                <IonCol size="6">
                                    <IonText color="primary" style={{ fontSize: '1.5em' }}>{vacancies}</IonText>
                                    <h6>Vacant</h6>
                                </IonCol>
                                <IonCol size="6">
                                    <IonText color="primary" style={{ fontSize: '1.5em' }}>{occupied}</IonText>
                                    <h6>Occupied</h6>
                                </IonCol>
                            </IonRow>
                        </IonCol>
                        <IonCol size="12" sizeMd="5" className="text-center order-2 order-md-2 mb-2 mb-md-0">
                            <div style={{ position: 'relative', width: '125px', height: '125px', margin: '0 auto' }}>
                                <Doughnut data={doughnutData} options={doughnutOptions} />
                                <div style={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    fontSize: '24px',
                                    color: colorTheme.primary["700"]
                                }}>
                                    <IonText color={"primary"}>{percentageOccupied}%</IonText>
                                </div>
                            </div>
                        </IonCol>
                        <IonCol size="12" sizeMd="4" className="text-center order-3 order-md-3">
                            <div className="d-flex flex-column align-items-center">
                                <IonButton
                                    onClick={handleAddTenant}
                                    id='add-tenants-button'
                                    hidden={Object.values(setUserViewPerms).length === 0}
                                    fill='outline'
                                    style={{
                                        borderRadius: "10px",
                                        height: "fit-content",
                                        marginBottom: "10px",
                                    }}
                                >
                                    Add {options?.userAccountType === OCCUPANT_TYPE ? "Tenants" : "Members"}
                                </IonButton>
                                <IonButton
                                    onClick={handleDeleteTenant}
                                    id='delete-tenant-button'
                                    fill='outline'
                                    style={{
                                        borderRadius: "10px",
                                        height: "fit-content",
                                    }}
                                >
                                    Delete {options?.userAccountType === OCCUPANT_TYPE ? "Tenants" : "Members"}
                                </IonButton>
                            </div>
                        </IonCol>
                    </IonRow>
                    <hr color='lightgray' className='mt-2' />
                    <IonRow className="d-flex mt-2 justify-content-end align-items-end">
                        <IonButton id='view-properties-button' onClick={() => onClick()} size="lg" fill='outline' variant="primary">
                            View <IonIcon icon={chevronForward} />
                        </IonButton>
                    </IonRow>
                </IonGrid>
            </Card>
        </TremorCol>
    );
}

export default OccupancyCard;
